<template>
    <el-row type="flex" justify="end" style="margin-bottom: 20px;">
        <common-back/>
    </el-row>
</template>

<script>
    import CommonBack from "@/components/CommonBack";

    export default {
        name: "RightBack",
        components: {CommonBack}
    }
</script>

<style scoped>

</style>